import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { GatsbyBrowser } from 'gatsby';
import './src/styles/global.css';
import { Helmet } from 'react-helmet';

const queryClient = new QueryClient();

const GlobalWrapper: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	useEffect(() => {
		const handleRejection = (event: PromiseRejectionEvent) => {
			event.preventDefault();
			console.warn('Unhandled promise rejection:', event.reason);
		};

		window.addEventListener('unhandledrejection', handleRejection);

		return () => {
			window.removeEventListener('unhandledrejection', handleRejection);
		};
	}, []);

	return (
		<QueryClientProvider client={queryClient}>
			<Helmet>
				<meta name="google-site-verification" content="m0XfoeW_KnSkJ-LSPgVWKv_5SI5a6B_i7IYNbun3_Fw" />
			</Helmet>
			{children}
		</QueryClientProvider>
	);
};

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
	element,
}) => <GlobalWrapper>{element}</GlobalWrapper>;
